
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 19.68a1.07 1.07 0 001-1v-3.05a1.05 1.05 0 00-1-1.08 1.07 1.07 0 00-1.05 1.08v3A1.07 1.07 0 0021 19.68zM22 25.31v-3a1.05 1.05 0 00-1-1.07 1.07 1.07 0 00-1.05 1.07v3a1.07 1.07 0 002.13 0zM29.12 19.68a1.07 1.07 0 001-1v-3a1.08 1.08 0 00-1.05-1.08A1.05 1.05 0 0028 15.68v3a1.07 1.07 0 001.12 1zM29.08 21.22A1 1 0 0028 22.28v3a1.07 1.07 0 002.13 0v-3a1.07 1.07 0 00-1.05-1.06z","fill":"var(--primary-highlight)"}}),_c('path',{attrs:{"d":"M25 .49A24.51 24.51 0 1049.51 25 24.53 24.53 0 0025 .49zm10.4 18v20.6H15.45c-.57 0-.85-.23-.85-.83V11.62a.72.72 0 01.64-.71h19.45a.73.73 0 01.71.71z","fill":"var(--primary-highlight)"}}),_c('path',{attrs:{"fill":"var(--primary-highlight)","d":"M20.94 31.47h8.12v6.21h-8.12z"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/multiFill.svg